// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  restApiUrl: 'https://hwgtaruiga.execute-api.eu-west-3.amazonaws.com/develop',
  baseUrl:
    'https://h223n3llkbc5zn3ywrpw5gwxmu.appsync-api.eu-west-3.amazonaws.com/graphql',
  apiKey: 'da2-upjr6mvvenf2ze3q7a7wkbz2e4',
  selfUrl: 'https://admin-dev.noprod.cfasante.com/',
  url: 'https://dev.noprod.cfasante.com/',
  userPoolId: 'eu-west-3_4j7oLS5kd',
  userPoolWebClientId: '5dshrfsitss1mnim5ff3v84av2',
  region: 'eu-west-3',
  bucket: 'cfa-noprod-cfasante-assets-dev',
  identityPoolId: 'eu-west-3:ccf4a4ad-de22-46a3-8e1a-8e664614dcc9',

  aws_exports: {
    region: 'eu-west-3',
    userPoolId: 'eu-west-3_4j7oLS5kd',
    userPoolWebClientId: '5204a3t491g4lu192f9t6p95e7',
    identityPoolId: 'eu-west-3:ccf4a4ad-de22-46a3-8e1a-8e664614dcc9',
    mandatorySignIn: true
  }

  // PROD ENV VARIABLES
  // production: false,
  // restApiUrl: 'https://fj4s8caho8.execute-api.eu-west-3.amazonaws.com/prod',
  // baseUrl:
  //   'https://qtqtvhvnnrhvnj4dqhp6ylbm5y.appsync-api.eu-west-3.amazonaws.com/graphql',
  // apiKey: 'da2-s4henmr5jfavji3xsk7xyy7grm',
  // selfUrl: 'https://cfasante.fr/',
  // userPoolId: 'eu-west-3_tNVp0rywK',
  // userPoolWebClientId: '21vmd0mniua45dkdqu7hfahj5m',
  // region: 'eu-west-3',
  // bucket: 'cfa-prod-cfasante-assets-prod',
  // identityPoolId: 'eu-west-3:3f84f8f6-27a3-460c-aca8-81522929a0a0',

  // aws_exports: {
  //   region: 'eu-west-3',
  //   userPoolId: 'eu-west-3_tNVp0rywK',
  //   userPoolWebClientId: '21vmd0mniua45dkdqu7hfahj5m',
  //   identityPoolId: 'eu-west-3:3f84f8f6-27a3-460c-aca8-81522929a0a0',
  //   mandatorySignIn: true
  // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
